export const ensureApiSuffix = (url) => {
  if (!url) return '/api';
  const normalized = url.endsWith('/') ? url.slice(0, -1) : url;
  return normalized.endsWith('/api') ? normalized : `${normalized}/api`;
};

export const resolveApiBaseUrl = ({ envUrl, isDev } = {}) => {
  const configuredUrl = envUrl?.trim();
  if (configuredUrl) return ensureApiSuffix(configuredUrl);
  if (isDev) return '/api';
  return ensureApiSuffix('https://api.eduvibz.com');
};
